import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileTemplateRequestBody, FileTemplateResponse } from "./types";

export class FileTemplateAPI extends BaseAPI<
  FileTemplateRequestBody,
  FileTemplateResponse
> {
  protected route = ApiRoutes.file.templates;
  protected method = RequestMethod.GET;
  protected params = ["menu_id"];
}
